import * as React from "react"
const Trophy = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={ 41 }
        height={ 41 }
        fill="none"
        { ...props }
    >
        <path fill="url(#a)" d="M18.55 19.105h3.1v7.908h-3.1v-7.908Z" />
        <path
            fill="url(#b)"
            d="M16.599 30.397c0-2.17 1.566-3.945 3.501-3.945 1.935 0 3.501 1.775 3.501 3.945H16.6Z"
        />
        <path
            fill="url(#c)"
            d="M15.18 30.397h9.84c.902 0 1.64.828 1.64 1.84v3.218H13.54v-3.219c0-1.011.738-1.839 1.64-1.839Z"
        />
        <path
            fill="url(#d)"
            d="M12.515 35.455h15.17c1.247 0 2.255 1.13 2.255 2.529 0 1.397-1.009 2.529-2.255 2.529h-15.17c-1.247 0-2.255-1.132-2.255-2.53 0-1.397 1.008-2.528 2.255-2.528Z"
        />
        <path
            fill="url(#e)"
            d="M23.421 29.606c-.205 0-.385-.174-.41-.413-.025-.258.14-.479.369-.506.05-.01 3.091-.396 5.994-2.989 3.846-3.439 5.724-9.223 5.412-16.708-.008-.258.164-.47.394-.478.221-.019.418.183.426.441.172 4.35-.344 8.138-1.55 11.265-.975 2.52-2.386 4.616-4.206 6.234-3.1 2.75-6.257 3.145-6.388 3.154h-.041Z"
        />
        <path
            fill="url(#f)"
            d="M38.362 14.323c-1.444 1.343-3.486 1.242-3.486 1.242s.296-2.272 1.739-3.614c1.443-1.343 3.485-1.242 3.485-1.242s-.295 2.272-1.738 3.614Z"
        />
        <path
            fill="url(#g)"
            d="M34.048 11.565c1.075 1.72.82 4 .82 4s-1.992-.515-3.067-2.235c-1.074-1.72-.82-4-.82-4s1.993.515 3.067 2.235Z"
        />
        <path
            fill="url(#h)"
            d="M32.958 16.54c.943 1.82.516 4.064.516 4.064s-1.951-.708-2.886-2.52c-.943-1.82-.517-4.064-.517-4.064s1.952.699 2.887 2.52Z"
        />
        <path
            fill="url(#i)"
            d="M31.154 21.21c.377 2.06-.665 4.038-.665 4.038s-1.648-1.361-2.017-3.421c-.369-2.06.665-4.037.665-4.037s1.64 1.361 2.017 3.42Z"
        />
        <path
            fill="url(#j)"
            d="M28.276 24.917c-.386 2.06-2.042 3.411-2.042 3.411s-1.034-1.986-.648-4.037c.385-2.05 2.042-3.411 2.042-3.411s1.033 1.977.648 4.037Z"
        />
        <path
            fill="url(#k)"
            d="M37.041 19.721c-1.541 1.186-3.575.883-3.575.883s.476-2.235 2.026-3.42c1.55-1.187 3.575-.884 3.575-.884s-.476 2.235-2.026 3.421Z"
        />
        <path
            fill="url(#l)"
            d="M34.155 25.285c-1.747.763-3.657-.047-3.657-.047s.918-2.05 2.665-2.813c1.746-.764 3.657.046 3.657.046s-.919 2.05-2.665 2.814Z"
        />
        <path
            fill="url(#m)"
            d="M29.587 29.947c-1.877-.055-3.353-1.637-3.353-1.637s1.558-1.49 3.427-1.435c1.87.055 3.354 1.637 3.354 1.637s-1.558 1.49-3.428 1.435Z"
        />
        <path
            fill="url(#n)"
            d="M36.607 7.859c0 2.105-1.37 3.807-1.37 3.807s-1.37-1.702-1.37-3.807c0-2.106 1.362-3.807 1.362-3.807s1.378 1.7 1.378 3.807Z"
        />
        <path
            fill="url(#o)"
            d="M16.779 29.606c.205 0 .385-.174.41-.413.025-.258-.14-.479-.37-.506-.048-.01-3.09-.396-5.993-2.989C6.98 22.26 5.102 16.475 5.414 8.99c.008-.258-.164-.47-.394-.478-.221-.019-.418.183-.426.441-.18 4.35.344 8.138 1.55 11.265.975 2.52 2.386 4.616 4.206 6.234 3.1 2.75 6.257 3.145 6.388 3.154h.04Z"
        />
        <path
            fill="url(#p)"
            d="M1.838 14.323c1.444 1.343 3.494 1.242 3.494 1.242s-.296-2.272-1.739-3.614C2.15 10.608.1 10.709.1 10.709s.295 2.272 1.738 3.614Z"
        />
        <path
            fill="url(#q)"
            d="M6.152 11.565c-1.075 1.72-.82 4-.82 4s1.992-.515 3.066-2.235c1.075-1.72.82-4 .82-4s-1.992.515-3.066 2.235Z"
        />
        <path
            fill="url(#r)"
            d="M7.242 16.54c-.935 1.82-.516 4.064-.516 4.064s1.951-.708 2.886-2.52c.935-1.811.517-4.064.517-4.064s-1.952.699-2.887 2.52Z"
        />
        <path
            fill="url(#s)"
            d="M9.046 21.21c-.377 2.06.664 4.038.664 4.038s1.649-1.361 2.026-3.421c.377-2.06-.664-4.037-.664-4.037s-1.649 1.361-2.026 3.42Z"
        />
        <path
            fill="url(#t)"
            d="M11.925 24.917c.385 2.06 2.041 3.411 2.041 3.411s1.034-1.986.648-4.037c-.385-2.05-2.042-3.411-2.042-3.411s-1.033 1.977-.647 4.037Z"
        />
        <path
            fill="url(#u)"
            d="M3.159 19.721c1.541 1.186 3.575.883 3.575.883s-.476-2.235-2.026-3.42c-1.55-1.187-3.575-.884-3.575-.884s.476 2.235 2.026 3.421Z"
        />
        <path
            fill="url(#v)"
            d="M6.045 25.285c1.747.763 3.657-.047 3.657-.047s-.918-2.05-2.657-2.813c-1.746-.764-3.657.046-3.657.046s.91 2.05 2.657 2.814Z"
        />
        <path
            fill="url(#w)"
            d="M10.612 29.947c1.878-.055 3.354-1.637 3.354-1.637s-1.558-1.49-3.427-1.435c-1.87.055-3.354 1.637-3.354 1.637s1.558 1.49 3.427 1.435Z"
        />
        <path
            fill="url(#x)"
            d="M3.593 7.859c0 2.105 1.37 3.807 1.37 3.807s1.37-1.702 1.37-3.807c0-2.106-1.37-3.807-1.37-3.807s-1.37 1.7-1.37 3.807Z"
        />
        <path
            fill="url(#y)"
            d="m22.134 1.89 1.87 4 3.976.755c1.829.35 2.559 2.86 1.263 4.34l-2.82 3.237.581 4.47c.271 2.059-1.631 3.604-3.296 2.684L20.1 19.381l-3.608 2.005c-1.665.92-3.567-.626-3.297-2.686l.583-4.469-2.821-3.237c-1.296-1.49-.566-3.99 1.263-4.34l3.977-.754 1.87-4c.86-1.848 3.206-1.848 4.067-.01Z"
        />
        <defs>
            <linearGradient
                id="a"
                x1={ 20.1 }
                x2={ 20.1 }
                y1={ 27.011 }
                y2={ 19.105 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FCD34F" />
                <stop offset={ 1 } stopColor="#FF6A00" />
            </linearGradient>
            <linearGradient
                id="b"
                x1={ 20.1 }
                x2={ 20.1 }
                y1={ 26.449 }
                y2={ 30.398 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FCD34F" />
                <stop offset={ 1 } stopColor="#FF6A00" />
            </linearGradient>
            <linearGradient
                id="c"
                x1={ 20.1 }
                x2={ 20.1 }
                y1={ 35.455 }
                y2={ 30.398 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#3D5969" />
                <stop offset={ 1 } stopColor="#698999" />
            </linearGradient>
            <linearGradient
                id="d"
                x1={ 20.1 }
                x2={ 20.1 }
                y1={ 40.513 }
                y2={ 35.455 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F90" />
                <stop offset={ 1 } stopColor="#FCD34F" />
            </linearGradient>
            <linearGradient
                id="e"
                x1={ 29.328 }
                x2={ 29.328 }
                y1={ 8.505 }
                y2={ 29.607 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F90" />
                <stop offset={ 1 } stopColor="#FCD34F" />
            </linearGradient>
            <linearGradient
                id="f"
                x1={ 37.463 }
                x2={ 37.465 }
                y1={ 15.586 }
                y2={ 10.732 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F90" />
                <stop offset={ 1 } stopColor="#FCD34F" />
            </linearGradient>
            <linearGradient
                id="g"
                x1={ 32.937 }
                x2={ 32.938 }
                y1={ 15.619 }
                y2={ 9.382 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F90" />
                <stop offset={ 1 } stopColor="#FCD34F" />
            </linearGradient>
            <linearGradient
                id="h"
                x1={ 31.657 }
                x2={ 31.928 }
                y1={ 20.554 }
                y2={ 14.122 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F90" />
                <stop offset={ 1 } stopColor="#FCD34F" />
            </linearGradient>
            <linearGradient
                id="i"
                x1={ 29.813 }
                x2={ 29.811 }
                y1={ 25.226 }
                y2={ 17.766 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F90" />
                <stop offset={ 1 } stopColor="#FCD34F" />
            </linearGradient>
            <linearGradient
                id="j"
                x1={ 26.938 }
                x2={ 26.936 }
                y1={ 28.302 }
                y2={ 20.852 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F90" />
                <stop offset={ 1 } stopColor="#FCD34F" />
            </linearGradient>
            <linearGradient
                id="k"
                x1={ 36.206 }
                x2={ 36.399 }
                y1={ 20.717 }
                y2={ 16.157 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F90" />
                <stop offset={ 1 } stopColor="#FCD34F" />
            </linearGradient>
            <linearGradient
                id="l"
                x1={ 33.631 }
                x2={ 33.632 }
                y1={ 25.59 }
                y2={ 22.067 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F90" />
                <stop offset={ 1 } stopColor="#FCD34F" />
            </linearGradient>
            <linearGradient
                id="m"
                x1={ 29.636 }
                x2={ 29.635 }
                y1={ 29.997 }
                y2={ 26.919 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F90" />
                <stop offset={ 1 } stopColor="#FCD34F" />
            </linearGradient>
            <linearGradient
                id="n"
                x1={ 35.233 }
                x2={ 35.233 }
                y1={ 11.662 }
                y2={ 4.05 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F90" />
                <stop offset={ 1 } stopColor="#FCD34F" />
            </linearGradient>
            <linearGradient
                id="o"
                x1={ 10.872 }
                x2={ 10.872 }
                y1={ 8.505 }
                y2={ 29.607 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F90" />
                <stop offset={ 1 } stopColor="#FCD34F" />
            </linearGradient>
            <linearGradient
                id="p"
                x1={ 2.73 }
                x2={ 2.729 }
                y1={ 15.58 }
                y2={ 10.726 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F90" />
                <stop offset={ 1 } stopColor="#FCD34F" />
            </linearGradient>
            <linearGradient
                id="q"
                x1={ 7.284 }
                x2={ 7.283 }
                y1={ 15.619 }
                y2={ 9.382 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F90" />
                <stop offset={ 1 } stopColor="#FCD34F" />
            </linearGradient>
            <linearGradient
                id="r"
                x1={ 8.556 }
                x2={ 8.284 }
                y1={ 20.544 }
                y2={ 14.114 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F90" />
                <stop offset={ 1 } stopColor="#FCD34F" />
            </linearGradient>
            <linearGradient
                id="s"
                x1={ 10.395 }
                x2={ 10.392 }
                y1={ 25.238 }
                y2={ 17.78 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F90" />
                <stop offset={ 1 } stopColor="#FCD34F" />
            </linearGradient>
            <linearGradient
                id="t"
                x1={ 13.232 }
                x2={ 13.244 }
                y1={ 28.277 }
                y2={ 20.827 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F90" />
                <stop offset={ 1 } stopColor="#FCD34F" />
            </linearGradient>
            <linearGradient
                id="u"
                x1={ 3.993 }
                x2={ 3.8 }
                y1={ 20.723 }
                y2={ 16.164 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F90" />
                <stop offset={ 1 } stopColor="#FCD34F" />
            </linearGradient>
            <linearGradient
                id="v"
                x1={ 6.587 }
                x2={ 6.585 }
                y1={ 25.587 }
                y2={ 22.065 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F90" />
                <stop offset={ 1 } stopColor="#FCD34F" />
            </linearGradient>
            <linearGradient
                id="w"
                x1={ 10.564 }
                x2={ 10.565 }
                y1={ 29.997 }
                y2={ 26.919 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F90" />
                <stop offset={ 1 } stopColor="#FCD34F" />
            </linearGradient>
            <linearGradient
                id="x"
                x1={ 4.967 }
                x2={ 4.967 }
                y1={ 11.662 }
                y2={ 4.05 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F90" />
                <stop offset={ 1 } stopColor="#FCD34F" />
            </linearGradient>
            <linearGradient
                id="y"
                x1={ 20.1 }
                x2={ 20.1 }
                y1={ 21.66 }
                y2={ 0.511 }
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F90" />
                <stop offset={ 0.11 } stopColor="#FFA200" />
                <stop offset={ 0.37 } stopColor="#FFB300" />
                <stop offset={ 0.65 } stopColor="#FFBD00" />
                <stop offset={ 1 } stopColor="#FFC100" />
            </linearGradient>
        </defs>
    </svg>
)
export default Trophy
